import Button from "./Button.svelte";
import { initComponentsByClassName } from "/shared/svelte";

$(() => {
  initComponentsByClassName("guestQuestion", Button);
});
